module.exports = __webpack_public_path__ + "static/media/forgot_image.7aa986ae.png";